// Module
var code = "<div class=\"drilldown-popup-main\">\n    <div class=\"item\">\n        <a ng-href eat-click-if=\"!hasPermission('insights')\" ng-click=\"drillDown('insights.association')\">See more</a>\n    </div>\n</div>\n";
// Exports
module.exports = code;